import { createAsyncActionTypes } from 'misc/utils';

const PREFIX = 'templates';

export const CREATE = createAsyncActionTypes(`${PREFIX}/CREATE`);
export const LIST = createAsyncActionTypes(`${PREFIX}/LIST`);
export const RETRIEVE = createAsyncActionTypes(`${PREFIX}/RETRIEVE`);
export const UPDATE = createAsyncActionTypes(`${PREFIX}/UPDATE`);
export const REMOVE = createAsyncActionTypes(`${PREFIX}/REMOVE`);